import tw from "twin.macro";
import AboutUs from "./Components/AboutUs";
import Footer from "./Components/Footer";
import Hero from "./Components/Hero";
import NewsLetter from "./Components/NewLetter";
import Services from "./Components/Services";
import WebHeader from "./Components/WebHeader";
import Sections from "./Components/Sections";
import ScrollAnimation from "./Components/ScrollAnimation";
import HeroSection16 from "./Components/Hero2";
import Hero3 from "./Components/Hero3";
import WhatsIsTtm from "./Components/What_Is_Ttm";
import ScrollPositionFixer from "./Components/scrolly";

const Home = () => {
  return (
    <>
      <WebHeader />
      <Hero3 />
      <WhatsIsTtm />
      {/* <Hero /> */}
      {/* <HeroSection16 /> */}

      <ScrollAnimation />
      {/* <ScrollPositionFixer /> */}
      <Sections />

      {/* <Menu /> */}
      {/* <Banner /> */}
      {/* <AboutUs />
      <NewsLetter /> */}
      <Services />
      <Footer />
    </>
  );
};

export default Home;
